import 'lazysizes';
import 'picturefill';

import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    const form = document.getElementById('commercial_operation_form');
    if (form !== null) {
        FormValidation.formValidation(form, {
            fields: {
                'commercial_operation[lead][email]': {
                    validators: {
                        notEmpty: {
                            message: "Adresse email obligatoire."
                        },
                        emailAddress: {
                            message: "Adresse email invalide."
                        }
                    }
                },
                'commercial_operation[lead][lastname]': {
                    validators: {
                        notEmpty: {
                            message: "Nom obligatoire."
                        }
                    }
                },
                'commercial_operation[lead][firstname]': {
                    validators: {
                        notEmpty: {
                            message: "Prénom obligatoire."
                        }
                    }
                }

            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }
});

$(document).ready(function () {
    $.each($('.item-card--promo'), function(i,e) {
        var link = $(e).find('a').attr('href');
        $(e).on('click', function(elem) {
            window.location = link;
        });
    });

});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/commercial_operation/commercial_operation.js